/**
 * Array#includesのponyfill
 * @param items
 * @param target
 */
export const includes = <T>(items: readonly T[], target: T): boolean => {
  return items.indexOf(target) !== -1;
};
